import { useEffect, useState } from "react";
import FilterByField from "./filterByField";
import { useAppDispatch, useAppSelector } from "../../redux/stateHooks";
import {
  clearObject,
  getCrossFilters,
  getFilters,
  getObjectName,
  getObjectSelectedFields,
  getObjectSeletedRecords,
  setObjectDetails,
} from "../../redux/reducers/objectSlice";
import CrossFilter from "./crossFilter";
import {
  convertDate,
  generateWhereClause,
  getFromStorage,
} from "../../utils/helpers";
import SavePopup from "../SavePopup/savePopup";
import {
  getAssetFolder,
  getDocumentPaths,
  getPlatform,
  openDataMergePanelAndSelectCSV,
  openXMLMergePanelAndSelectXML,
  saveBase64AsFileWithCEP,
  saveCSVToFile,
  saveJSONdataAsFile,
  saveXMLToFile,
  showAlertInInDesign,
  toogleStructurePane,
  normalizePath,
} from "../../utils/inDesignServices";
import { API, LocalStorageKeys, mergeStyle } from "../../utils/constant";
import axios from "axios";
import {
  getImageFromRichText,
  getImageFromUrl,
} from "../../services/apiService";

function Filter({ imageColumns }) {
  const dispatch = useAppDispatch();
  const title = useAppSelector(getObjectName);
  const filterFields = useAppSelector(getObjectSelectedFields);
  const seletedRecords = useAppSelector(getObjectSeletedRecords);

  const _filters = useAppSelector(getFilters);
  const [filters, setFilters] = useState(
    _filters || [{ field: "", operator: "", value: "", type: "" }]
  );

  const _crossFilters = useAppSelector(getCrossFilters);
  // console.log(_crossFilters);
  const [crossFilters, setCrossFilters] = useState(_crossFilters || []);
  const [savePopup, setSavePopup] = useState(false);

  const handleAddFilter = () => {
    setFilters([...filters, { field: "", operator: "", value: "", type: "" }]);
  };
  const handleAddCrossFilter = () => {
    setCrossFilters([
      ...crossFilters,
      {
        childSObject: "",
        relationshipName: "",
        withOrWithout: "",
        field: "",
        filters: [{ field: "", operator: "", value: "", type: "" }],
      },
    ]);
  };

  // const handleApplyFilter = () => {
  //   dispatch(setObjectDetails({ filters, crossFilters }));

  //   let _with = [];
  //   let _without = [];
  //   for (let cf of crossFilters) {
  //     if (cf.withOrWithout == "with") {
  //       _with.push(cf.relationshipName);
  //     }
  //     if (cf.withOrWithout == "without") {
  //       _without.push(cf.relationshipName);
  //     }
  //   }

  //   let crossQueries = [];
  //   for (let crossFilter of crossFilters) {
  //     if (crossFilter.field == "" || crossFilter.relationshipName == "")
  //       continue;
  //     let crossQuery = `SELECT ${crossFilter.field},Id from ${
  //       crossFilter.relationshipName
  //     } ${generateWhereClause(crossFilter.filters)}`;
  //     crossQueries.push(crossQuery);
  //   }

  //   let _crossQueries = "";
  //   if (crossQueries.length > 0)
  //     _crossQueries = ", (" + crossQueries.join(") , (") + ")";

  //   // Construct the SELECT clause
  //   const selectClause =
  //     filterFields.length > 0 ? filterFields.join(", ") : "*";

  //   let whereClause = generateWhereClause(filters);

  //   // Construct the final SQL query
  //   const sqlQuery = `SELECT ${selectClause} ${_crossQueries} FROM ${title} ${whereClause}`;

  //   // // console.log("Generated SQL Query:", sqlQuery);
  //   dispatch(
  //     setObjectDetails({ soql: sqlQuery, with: _with, without: _without })
  //   );
  // };

  const handleApplyFilter = () => {
    dispatch(setObjectDetails({ filters, crossFilters }));
    // Define a mapping of operators to SQL syntax
    const operatorMapping = {
      text: {
        is: "=",
        contains: "LIKE",
        startsWith: "LIKE",
        endsWith: "LIKE",
        isNot: "!=",
        doesNotHave: "NOT LIKE",
      },
      number: {
        equals: "=",
        greaterThan: ">",
        lessThan: "<",
        notEqual: "!=",
      },
      date: {
        is: "=",
        before: "<",
        after: ">",
        not: "!=",
      },
    };

    // Function to construct the SQL where clause based on type, operator, and value
    const generateWhereClauseForFilter = (filter) => {
      const { type, operator, field, value } = filter;
      if (type == "" || operator == "" || field == "" || value == "") {
        return "";
      }
      const sqlOperator = operatorMapping[type][operator]; // Get corresponding SQL operator

      // For text-based operators like 'LIKE', adjust the value accordingly
      if (type === "text") {
        switch (operator) {
          case "contains":
            return `${field} ${sqlOperator} '%${value}%'`;
          case "startsWith":
            return `${field} ${sqlOperator} '${value}%'`;
          case "endsWith":
            return `${field} ${sqlOperator} '%${value}'`;
          case "doesNotHave":
            return `${field} ${sqlOperator} '%${value}%'`;
          default:
            return `${field} ${sqlOperator} '${value}'`;
        }
      }

      // For number or date types, no need to adjust the value, just use the operator directly
      if (type === "number") {
        return `${field} ${sqlOperator} ${value}`;
      }
      if (type === "date") {
        return `${field} ${sqlOperator} ${convertDate(value)}`;
      }

      return "";
    };

    // Generate the where clause for each filter
    const whereClauses = filters
      .map((filter) => generateWhereClauseForFilter(filter))
      .filter((x) => x != "");
    // console.log("whereClauses", whereClauses);

    // Join all the clauses with "AND" to form the final where clause
    const whereClause =
      whereClauses.length > 0 ? `WHERE ${whereClauses.join(" AND ")}` : "";

    // Handling cross filters as before
    let _with = [];
    let _without = [];
    for (let cf of crossFilters) {
      if (cf.withOrWithout === "with") {
        _with.push(cf.relationshipName);
      }
      if (cf.withOrWithout === "without") {
        _without.push(cf.relationshipName);
      }
    }

    let crossQueries = [];
    for (let crossFilter of crossFilters) {
      if (crossFilter.field === "" || crossFilter.relationshipName === "")
        continue;
      let crossQuery = `SELECT ${crossFilter.field}, Id from ${
        crossFilter.relationshipName
      } ${generateWhereClause(crossFilter.filters)}`;
      crossQueries.push(crossQuery);
    }

    let _crossQueries = "";
    if (crossQueries.length > 0)
      _crossQueries = ", (" + crossQueries.join(") , (") + ")";

    // Construct the SELECT clause
    const selectClause =
      filterFields.length > 0 ? filterFields.join(", ") : "*";

    // Construct the final SQL query
    const sqlQuery = `SELECT ${selectClause} ${_crossQueries} FROM ${title} ${whereClause}`;

    console.log("Generated SQL Query:", sqlQuery);

    // Dispatch final SQL query details
    dispatch(
      setObjectDetails({ soql: sqlQuery, with: _with, without: _without })
    );
  };

  const handleResetFilter = () => {
    setFilters([{ field: "", operator: "", value: "", type: "" }]);
    setCrossFilters([]);
    dispatch(
      setObjectDetails({
        soql: undefined,
        filters: undefined,
        crossFilters: undefined,
        with: undefined,
        without: undefined,
      })
    );
  };
  const handleBack = () => {
    dispatch(setObjectDetails({ records: undefined }));
  };
  const handleCancel = () => {
    dispatch(clearObject());
  };

  const prepareCSVData = async (data) => {
    console.log("Preparing CSV data", data);

    // Escape values containing commas by wrapping them in double quotes
    const escapeValue = (value) => {
      if (typeof value === "string" && value.includes(",")) {
        return `"${value.replace(/"/g, '""')}"`; // Escape existing double quotes
      }
      return value;
    };

    // Create CSV headers, add "@" before any header that contains "image" or "photo"
    const headers = Object.keys(data[0]).map((header) => {
      // Check if any value in the column contains an <img> tag
      const containsImageTag = data.some(
        (row) =>
          row[header] && /<img\s+[^>]*src=["']([^"']+)["']/.test(row[header])
      );

      return imageColumns.includes(header) || containsImageTag
        ? `@${header}`
        : header;
    });
    const assetFolder = await getAssetFolder();
    const platform = await getPlatform();

    // Process each row of data
    const rows = await Promise.all(
      data.map(async (row, record_row_number) => {
        // Process each value in the row
        const values = await Promise.all(
          Object.values(row).map(async (value, index) => {
            const header = Object.keys(row)[index];

            if (
              (typeof value === "string" && imageColumns.includes(header)) ||
              (typeof value === "string" &&
                /<img\s+[^>]*src=["']([^"']+)["']/.test(value))
            ) {
              let response;
              try {
                if (/<img\s+[^>]*src=["']([^"']+)["']/.test(value)) {
                  response = await getImageFromRichText(
                    title,
                    row["Id"],
                    header,
                    value?.match(/refid=([^"&]+)/)?.[1],
                    {
                      responseType: "arraybuffer",
                    }
                  );
                } else {
                  // Fetch the image data as base64 from the URL
                  response = await getImageFromUrl(encodeURIComponent(value), {
                    responseType: "arraybuffer",
                  });
                }
                console.log("response.data", response);
                const base64Image = Buffer.from(
                  response.data,
                  "binary"
                ).toString("base64");

                // Construct a file name from the image URL
                // const fileExtension = value.split(".").pop() || "png"; // Default to png if no extension
                const fileExtension = "png"; // Default to png if no extension
                const imageName = `${row["Id"]}_${header}.${fileExtension}`;
                const filePath = `${assetFolder}/${imageName}`;

                // Save the image using CEP (ExtendScript)
                const res = await saveBase64AsFileWithCEP(
                  filePath,
                  base64Image
                );

                return normalizePath(filePath, platform);
              } catch (error) {
                console.error("Failed to download image:", error);
                return "image_error"; // Return some placeholder on failure
              }
            } else {
              // For non-image fields, just escape the value
              return escapeValue(value);
            }
          })
        );
        return values.join(",");
      })
    );

    // Join headers and rows into a single CSV string
    return `${headers.join(",")}\n${rows.join("\n")}`;
  };

  const generateXMLData = async (data) => {
    const xmlHeader = `<?xml version="1.0" encoding="UTF-8"?>\n<root>`;
    const xmlFooter = `</root>`;

    const escapeXML = (str) => {
      if (typeof str === "string") {
        return str
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      }
      return str;
    };

    const assetFolder = await getAssetFolder();
    const platform = await getPlatform();

    const xmlBody = await Promise.all(
      data.map(async (record, record_row_number) => {
        const fields = await Promise.all(
          Object.keys(record).map(async (key) => {
            const value = record[key];

            if (
              (typeof value === "string" && imageColumns.includes(key)) ||
              (typeof value === "string" &&
                /<img\s+[^>]*src=["']([^"']+)["']/.test(value))
            ) {
              try {
                let response;
                if (/<img\s+[^>]*src=["']([^"']+)["']/.test(value)) {
                  response = await getImageFromRichText(
                    title,
                    record["Id"],
                    key,
                    value?.match(/refid=([^"&]+)/)?.[1],
                    {
                      responseType: "arraybuffer",
                    }
                  );
                } else {
                  response = await getImageFromUrl(encodeURIComponent(value), {
                    responseType: "arraybuffer",
                  });
                }

                const base64Image = Buffer.from(
                  response.data,
                  "binary"
                ).toString("base64");

                const fileExtension = "png"; // Default to png if no extension
                const imageName = `${record["Id"]}_${key}.${fileExtension}`;
                const filePath = `${assetFolder}/${imageName}`;

                await saveBase64AsFileWithCEP(filePath, base64Image);

                const normalizedImageHref = normalizePath(filePath, platform);
                return `<img href="${normalizedImageHref}" />`;
              } catch (error) {
                console.error("Failed to download image:", error);
                return '<img href="image_error" />';
              }
            } else {
              return `<${key}>${escapeXML(value)}</${key}>`;
            }
          })
        );
        return `<record>\n${fields.join("\n")}\n</record>`;
      })
    );

    // Return the complete XML string
    return `${xmlHeader}\n${xmlBody.join("\n")}\n${xmlFooter}`;
  };

  const handleMerge = async () => {
    // console.log("selectec rows", seletedRecords);
    const paths = await getDocumentPaths();
    // console.log("paths", paths);
    if (paths?.error) {
      console.error(
        "Could not retrieve document paths. Ensure the document is saved."
      );
      await showAlertInInDesign(paths?.error as string, "Something Went Wrong");
      return;
    }

    const { templateFilePath } = paths;
    // Your data to be merged
    const data = seletedRecords;

    const config = await getFromStorage(LocalStorageKeys.CONFIG);
    const _mergeStyle = config?.mergeStyle || mergeStyle.DATA_MERGE;
    console.log("_mergeStyle", _mergeStyle);
    if (_mergeStyle == mergeStyle.XML_MERGE) {
      const xmlData = await generateXMLData(data);
      dispatch(setObjectDetails({ isLoading: true }));
      const xmlFilePath = templateFilePath.replace(/\.indd$/, ".xml");
      const xmlSaved = await saveXMLToFile(xmlFilePath, xmlData);
      console.log("xmlsaved", xmlSaved);
      if ((xmlSaved as string).includes("Error")) {
        await showAlertInInDesign(xmlSaved as string, "Something Went Wrong");
        dispatch(setObjectDetails({ isLoading: false }));
        return;
      }
      console.log("xmlFilePath", xmlFilePath);
      if (xmlSaved) {
        const mergeResult = await openXMLMergePanelAndSelectXML(xmlFilePath);
        // console.log(mergeResult);
        if ((mergeResult as string).includes("Error")) {
          await showAlertInInDesign(
            mergeResult as string,
            "Something Went Wrong"
          );
        } else {
          await toogleStructurePane();
          await showAlertInInDesign("Data merged succesfully", "Success");
        }
      } else {
        console.error("Failed to save CSV file.");
        await showAlertInInDesign(
          "Failed to save CSV file.",
          "Something Went Wrong"
        );
      }
      dispatch(setObjectDetails({ isLoading: false }));
    } else {
      const csvData = await prepareCSVData(data);
      dispatch(setObjectDetails({ isLoading: true }));
      const csvFilePath = templateFilePath.replace(/\.indd$/, ".csv"); // Save CSV in the same directory
      // console.log("filepath", csvFilePath);
      console.log("csvData", csvFilePath, JSON.stringify(csvData));
      const csvSaved = await saveCSVToFile(csvFilePath, csvData);
      if ((csvSaved as string).includes("Error")) {
        await showAlertInInDesign(csvSaved as string, "Something Went Wrong");
        dispatch(setObjectDetails({ isLoading: false }));
        return;
      }
      // console.log("csvSaved", csvSaved);

      if (csvSaved) {
        const mergeResult = await openDataMergePanelAndSelectCSV(csvFilePath);
        // console.log(mergeResult);
        if ((mergeResult as string).includes("Error")) {
          await showAlertInInDesign(
            mergeResult as string,
            "Something Went Wrong"
          );
        } else {
          await showAlertInInDesign("Data merged succesfully", "Success");
        }
      } else {
        console.error("Failed to save CSV file.");
      }
      dispatch(setObjectDetails({ isLoading: false }));
    }
  };

  return (
    <div className="cnt-space">
      <div className="leftside">
        <fieldset className="less-space icon-position">
          <legend>Add Filters</legend>
          <div className="filter-icon d-flex">
            <div
              className={`filter-style field-icon cursor-pointer`}
              onClick={handleAddFilter}
            >
              <i className="icon-type-20 field-filter"></i>
              {" Field"}
            </div>
            <div
              className={`filter-style field-icon cursor-pointer`}
              onClick={handleAddCrossFilter}
            >
              <i className="icon-type-20 cross-filter"></i>
              {" Cross"}
            </div>
          </div>

          <div className="filterBox !mt-10">
            <ul className="">
              <li className="d-flex">
                <div className="col1">
                  <span className="number">&nbsp;</span>
                </div>
                <div className="coll col3">Field</div>
                <div className="coll col3">Type</div>
                <div className="coll col3">Operator</div>
                <div className="coll col3">Value</div>
                <div className="col6">
                  <span className="number block w-[27px]">&nbsp;</span>
                </div>
              </li>
            </ul>
          </div>
          <div className="filterBox">
            <div className="h-[15vh] max-h-[30vh] overflow-auto mt-[-10px]">
              <FilterByField
                title={title}
                filters={filters}
                setFilters={setFilters}
                filterFields={filterFields}
              />
              <CrossFilter
                title={title}
                crossFilters={crossFilters}
                setCrossFilters={setCrossFilters}
              />
            </div>
            <div className="filter-buttons clearfix">
              <button
                className="btn filter-btn float-left width110 filter-logic"
                type="button"
                onClick={() => {}}
              >
                <span>Add Filter Logic</span>
              </button>

              <button
                className="btn filter-btn float-right width110 ml-2"
                type="button"
                onClick={handleResetFilter}
              >
                Clear Filter
              </button>
              <button
                className="btn filter-btn float-right width110"
                type="button"
                onClick={handleApplyFilter}
              >
                Apply Filter
              </button>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="rightside text-right right-action">
        <button
          className="btn btn-primary active"
          type="button"
          onClick={() => {
            setSavePopup(true);
          }}
        >
          Save
        </button>
        <button
          className={`btn btn-primary ${
            seletedRecords?.length ? "active" : ""
          }`}
          type="button"
          disabled={!seletedRecords?.length}
          onClick={handleMerge}
        >
          Merge
        </button>
        <br />
        <button
          className="btn btn-primary active"
          type="button"
          onClick={handleBack}
        >
          Back
        </button>
        <br />
        <button
          className="btn btn-primary active"
          type="button"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </div>
      {savePopup ? (
        <SavePopup
          onCancel={() => {
            setSavePopup(false);
          }}
        />
      ) : null}
    </div>
  );
}

export default Filter;
